import React, {memo} from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useExecutionIfNotAuthenticated} from '@vio/core/src/auth/hooks/useExecutionIfNotAuthenticated'
import {Brand} from '@vio/core/src/brand/types'

import {AuthDialogLoadable} from './AuthDialog'
import Container, {ChildrenProps} from './Container'

type PasswordlessLoginPropsType = {
  brand: Brand
  languageCode: string
  anonymousId: string
  isPopupClosable?: boolean
}

export type ViewProps = ChildrenProps &
  PasswordlessLoginPropsType & {
    isMobile: boolean
  }

export const PasswordlessLogin = ({
  brand,
  languageCode,
  anonymousId,
  isPopupClosable = true
}: PasswordlessLoginPropsType) => {
  const {auth} = useBrandCapabilities()

  useExecutionIfNotAuthenticated(
    async () =>
      import(
        /* webpackPrefetch: true */ './AuthDialog/AuthDialog' /* webpackChunkName: "AuthDialog" */
      )
  )

  if (!auth.showSignIn) {
    return null
  }

  return (
    <>
      <Container
        languageCode={languageCode}
        anonymousId={anonymousId}
        brand={brand}
      >
        {({
          isOpen,
          authenticationFlow,
          handleCloseOverlay,
          handleSocialLoginClick,
          handleEmailLogin
        }) =>
          isOpen ? (
            <AuthDialogLoadable
              brand={brand}
              isOpen={isOpen}
              handleCloseOverlay={handleCloseOverlay}
              viewProps={{
                brand,
                handleSocialLoginClick,
                handleEmailLogin,
                handleCloseOverlay
              }}
              authenticationFlow={authenticationFlow}
              isPopupClosable={isPopupClosable}
            />
          ) : (
            <></>
          )
        }
      </Container>
    </>
  )
}

export default memo<PasswordlessLoginPropsType>(PasswordlessLogin)
